var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"block-title"},[_c('div',{staticClass:"container",class:_vm.type},[_c('div',{staticClass:"em-size"},[_vm._v(_vm._s(_vm.emName))]),_c('img',{staticClass:"img",attrs:{"src":"http://img.sicred.cn/assets/img/common/block-title-line.png"}}),_c('div',{staticClass:"zh-size"},[_vm._v(_vm._s(_vm.zhName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }